'use client';
import { Typography } from '@mui/material';
import { dynamicWithRetry } from '@repo/ui/DynamicWithRetry';
import type { Props as RevalidateLinkProps } from '@repo/ui/RevalidateLink';
import type { Props as WPAdminBarProps } from '@repo/ui/WPAdminBar';
import { useHasWPSession } from './hook';

const RevalidateLink = dynamicWithRetry<RevalidateLinkProps>(
  () =>
    import('@repo/ui/RevalidateLink').then(mod => ({
      default: mod.default,
    })),
  {
    componentName: 'RevalidateLink',
    ssr: false,
  },
);

const UpdateAbsmartlyContextLink = dynamicWithRetry<Record<string, never>>(
  () =>
    import('@repo/ui/UpdateAbsmartlyContextLink').then(mod => ({
      default: mod.default,
    })),
  {
    componentName: 'UpdateAbsmartlyContextLink',
    ssr: false,
  },
);

const WPAdminBar = dynamicWithRetry<WPAdminBarProps>(
  () =>
    import('@repo/ui/WPAdminBar').then(mod => ({
      default: mod.default,
    })),
  {
    componentName: 'WPAdminBar',
    ssr: false,
  },
);

export type PageType = 'Roundup' | 'Review' | 'Calculator';

type Props = {
  id: string;
  pageType?: PageType;
  lastModified?: string;
};

export default function WordpressEditWrapper({ id, pageType, lastModified }: Props) {
  const { hasWPSession } = useHasWPSession();

  if (hasWPSession && pageType) {
    return (
      <>
        <WPAdminBar wpId={id} />
        {lastModified && (
          <Typography
            variant="textSmall"
            sx={{ position: 'absolute', right: 0, top: '180px', padding: 2, marginRight: 2 }}
          >
            Last modified at {lastModified}
          </Typography>
        )}
        <RevalidateLink label={`Refresh ${pageType}`} />
        <UpdateAbsmartlyContextLink />
      </>
    );
  }
  return null;
}
